export class BucketedRateLimiter {
    _options;
    _bucketSize;
    _refillRate;
    _refillInterval;
    _onBucketRateLimited;
    _buckets = {};
    _removeInterval;
    constructor(_options) {
        this._options = _options;
        this._onBucketRateLimited = this._options._onBucketRateLimited;
        this._bucketSize = clampToRange(this._options.bucketSize, 0, 100);
        this._refillRate = clampToRange(this._options.refillRate, 0, this._bucketSize);
        this._refillInterval = clampToRange(this._options.refillInterval, 0, 86400000);
        this._removeInterval = setInterval(() => {
            this._refillBuckets();
        }, this._refillInterval);
    }
    _refillBuckets = () => {
        Object.keys(this._buckets).forEach((key) => {
            const newTokens = this._getBucket(key) + this._refillRate;
            if (newTokens >= this._bucketSize) {
                delete this._buckets[key];
            }
            else {
                this._setBucket(key, newTokens);
            }
        });
    };
    _getBucket = (key) => {
        return this._buckets[String(key)];
    };
    _setBucket = (key, value) => {
        this._buckets[String(key)] = value;
    };
    consumeRateLimit = (key) => {
        let tokens = this._getBucket(key) ?? this._bucketSize;
        tokens = Math.max(tokens - 1, 0);
        if (tokens === 0) {
            return true;
        }
        this._setBucket(key, tokens);
        const hasReachedZero = tokens === 0;
        if (hasReachedZero) {
            this._onBucketRateLimited?.(key);
        }
        return hasReachedZero;
    };
    stop() {
        if (this._removeInterval) {
            clearInterval(this._removeInterval);
            this._removeInterval = undefined;
        }
    }
}
function clampToRange(value, min, max, fallbackValue) {
    if (min > max) {
        min = max;
    }
    if (!isNumber(value)) {
        return clampToRange(fallbackValue || max, min, max);
    }
    else if (value > max) {
        return max;
    }
    else if (value < min) {
        return min;
    }
    else {
        return value;
    }
}
export const isNumber = (x) => {
    return toString.call(x) == "[object Number]";
};
